import React from 'react';
import { Hero } from './components/Hero';
import { ProblemAgitation } from './components/ProblemAgitation';
import { ProductPresentation } from './components/ProductPresentation';
import { BonusStack } from './components/BonusStack';
import { AudienceFit } from './components/AudienceFit';
import { UpsellComparison } from './components/UpsellComparison';
import { PricingTiers } from './components/PricingTiers';
import { MoreTestimonials } from './components/MoreTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-white font-sans text-brand-navy" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemAgitation data-id="element-2" />
      <ProductPresentation data-id="element-3" />
      <BonusStack data-id="element-4" />
      <AudienceFit data-id="element-5" />
      <UpsellComparison data-id="element-6" />
      <PricingTiers data-id="element-7" />
      <MoreTestimonials data-id="element-8" />
      <Guarantee data-id="element-9" />
      <FAQ data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}